<template>
    <div class="d-flex text-caption align-center">
        <span v-if="flagIconCode" class="fi" :class="[`fi-${flagIconCode}`, 'me-2']" />
        <v-icon v-else size="small" start> mdi-translate </v-icon>
        <span
            class="language-label__text"
            style="margin-left: 2px"
            :class="{'text-button': textButton, 'font-weight-bold': bold}"
            v-text="showCurrentLang ? $t('lang') : translate ? langISOTranslate : $t(`languages.${language}`)"
        />
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'
    import {capitalizeTheFirstLetterOfEachWord} from '@/utils/helpers'
    import ISO6391 from 'iso-639-1'

    @Component
    export class LanguageLabel extends Vue {
        @Prop({required: true}) language
        @Prop({default: false, type: Boolean}) showCurrentLang
        @Prop({default: false, type: Boolean}) bold
        @Prop({default: false, type: Boolean}) textButton
        @Prop({default: false, type: Boolean}) translate

        get flagIconCode() {
            const lang = this.language.toLowerCase()

            const languageNames = new Intl.DisplayNames(['en'], {type: 'language'})

            switch (lang) {
                case 'ale':
                    return 'de'
                case 'cas':
                    return 'es'
                case 'local':
                case 'undefined':
                    return null
            }

            const langCode = ISO6391.getCode(languageNames.of(this.language))

            if (langCode === '') {
                return null
            }

            switch (langCode) {
                case 'en':
                    return 'gb'
                case 'el':
                    return 'gr'
                case 'zh':
                    return 'cn'
                case 'ar':
                    return 'sa'
                case 'kk':
                    return 'kz'
                case 'ja':
                    return 'jp'
                case 'sq':
                    return 'al'
                default:
                    return langCode
            }
        }

        get langISOTranslate() {
            if (this.language === 'LOCAL') {
                return this.$t('languages.local')
            }

            let lang = this.language.toLowerCase()

            if (lang === 'cas') {
                lang = 'es'
            } else if (lang === 'ale') {
                lang = 'de'
            } else if (lang === 'undefined') {
                return this.$t('other')
            }

            const languageNames = new Intl.DisplayNames([this.$i18n.locale], {type: 'language'})

            return capitalizeTheFirstLetterOfEachWord(languageNames.of(lang))
        }
    }

    export default LanguageLabel
</script>
